export enum DashboardTabsWidgetBlock {
  Root = 'DashboardTabsWidget',
}
